import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { 
  Typography
} from "antd";
import { TableComponent } from "../Master/CommonComponents";
import Heading from "../../components/Heading";
import "./style.scss";

const { Text } = Typography;

const HubSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [hubData, setHubData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
  });

  // Extract data from navigation state
  useEffect(() => {
    const { hubData: data } = location.state || {};
    if (data) {
      // Handle both single hub object and array of hubs
      let dataArray = [];
      if (Array.isArray(data)) {
        dataArray = data;
      } else {
        dataArray = [data];
      }
      setHubData(dataArray);
      setPagination(prev => ({
        ...prev,
        total: dataArray.length
      }));
    }
  }, [location.state]);

  // Table columns for hub data
  const columns = [
    {
      title: "No.",
      key: "index",
      width: 60,
      fixed: "left",
      render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Hub Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 200,
      render: (text) => <Text style={{ fontSize: "14px", fontWeight: "500" }}>{text || "NA"}</Text>,
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      width: 300,
      render: (text) => (
        <Text style={{ fontSize: "14px" }} ellipsis={{ tooltip: text }}>
          {text || "NA"}
        </Text>
      ),
    },
    {
      title: "Official Number",
      dataIndex: "officialNumber",
      key: "officialNumber",
      sorter: true,
      width: 140,
      render: (phone) => (
        phone && phone !== "0" && phone !== "null" ? (
          <Text style={{ fontSize: "14px" }}>{phone}</Text>
        ) : (
          <Text type="secondary" style={{ fontSize: "14px" }}>NA</Text>
        )
      ),
    },
    {
      title: "Personal Number",
      dataIndex: "personalNumber",
      key: "personalNumber",
      sorter: true,
      width: 140,
      render: (phone) => (
        phone && phone !== "0" && phone !== "null" ? (
          <Text style={{ fontSize: "14px" }}>{phone}</Text>
        ) : (
          <Text type="secondary" style={{ fontSize: "14px" }}>NA</Text>
        )
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
      width: 250,
      fixed: "right",
      render: (email) => (
        email ? (
          <Text style={{ fontSize: "14px" }}>{email}</Text>
        ) : (
          <Text type="secondary" style={{ fontSize: "14px" }}>NA</Text>
        )
      ),
    },
  ];

  // Custom back handler
  const goBackToPrevScreen = () => {
    if (window.history.length <= 1) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  // Handle table change for pagination, sorting, etc.
  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  return (
    <>
      <div className="p-2-tab">
        <Heading title="Hub Search" showBack={true} goBack={goBackToPrevScreen} />
      </div>

      {/* Main Data Table */}
      <div className="container">
        <TableComponent
          columns={columns}
          dataSource={hubData}
          loading={false}
          pagination={pagination}
          onChange={handleTableChange}
          rowKey={(record) => `${record.premiseId}-${record.name}`}
        />
      </div>
    </>
  );
};

export default HubSearch; 
